import type { JSX } from 'react';
import { TableCell, TableRow } from '@/components/ui/table';
import { Badge } from '@/components/ui/badge';
import { UserAvatar } from '@/components/atoms/UserAvatar';
import { SuperAdminActions } from './SuperAdminActions';
import type { SuperAdmin } from '../types/super-admin.types';

export interface SuperAdminRowProps {
  superAdmin: SuperAdmin;
  isCurrentUser: boolean;
  onEdit: (superAdmin: SuperAdmin) => void;
}

export function SuperAdminRow({
  superAdmin,
  isCurrentUser,
  onEdit,
}: SuperAdminRowProps): JSX.Element {
  const statusVariant = superAdmin.isActive ? 'default' : 'secondary';
  const statusLabel = superAdmin.isActive ? 'Active' : 'Inactive';

  return (
    <TableRow>
      <TableCell>
        <div className="flex items-center gap-3">
          <UserAvatar
            fullName={superAdmin.profile.fullName}
            photoUrl={superAdmin.profile.photoUrl}
          />
          <div className="flex flex-col">
            <span className="font-medium">{superAdmin.profile.fullName}</span>
            <span className="text-sm text-muted-foreground">{superAdmin.email}</span>
          </div>
        </div>
      </TableCell>
      <TableCell>
        <Badge variant="outline">SUPER_ADMIN</Badge>
      </TableCell>
      <TableCell>
        <Badge variant={statusVariant}>{statusLabel}</Badge>
      </TableCell>
      <TableCell>{new Date(superAdmin.createdAt).toLocaleDateString()}</TableCell>
      <TableCell className="text-right">
        <SuperAdminActions superAdmin={superAdmin} onEdit={onEdit} isCurrentUser={isCurrentUser} />
      </TableCell>
    </TableRow>
  );
}
